import * as R from 'ramda';
import {
  INIT,
  BACK,
  RESOLVE,
  REJECT,
  GO,
  RESET,
  CLEAN_ERROR,
} from './actions';

const initial = {
  steps: [],
  current: 0,
};

const init = (state, {
  current,
  steps,
}) => {
  const steps$ = steps.map(({
    index,
    stepId,
    completed = false,
    error = false,
    data,
  }, idx) => ({
    index: index || R.inc(idx),
    stepId: stepId || idx,
    completed,
    error,
    data,
  }));

  const current$ = R.findIndex(R.propEq('stepId', current))(steps$);

  return {
    ...state,
    current: current$,
    steps: steps$,
  };
};

const back = state => ({
  ...state,
  current: R.dec(state.current),
});

const go = (state, { idx }) => ({
  ...state,
  current: idx - 1,
});

const resolve = (state, { data }) => ({
  ...state,
  current: R.inc(state.current),
  steps: R.update(
    state.current,
    R.merge(
      state.steps[state.current],
      {
        data,
        completed: true,
        error: false,
      },
    ),
    state.steps,
  ),
});

const reject = (state, { error }) => ({
  ...state,
  steps: R.update(
    state.current,
    R.merge(
      state.steps[state.current],
      {
        error,
      },
    ),
    state.steps,
  ),
});

const reset = state => ({
  ...state,
  ...initial,
});

const cleanError = state => ({
  ...state,
  steps: R.update(
    state.current,
    R.merge(state.steps[state.current], { error: null }),
    state.steps,
  ),
});

export default (state = initial, action) => {
  const reducer = {
    [INIT]: init,
    [BACK]: back,
    [RESOLVE]: resolve,
    [REJECT]: reject,
    [GO]: go,
    [RESET]: reset,
    [CLEAN_ERROR]: cleanError,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};
